<template>
  <div :class="[ 'view-register', { '-full-content': !!user }]">
    <main class="content">
      <!-- Main Container -->
      <registration-container
        v-if="!user"
        class="new-register-form"
        :no-heading="noHeading"
        @success="redirect"
      />
    </main>
  </div>
</template>

<script>
import { MediaQuery } from '@convenia/mixins'
import RegistrationContainer from '@containers/NewRegistration'

export default {
  name: 'Embed',

  data: () => ({
    user: null
  }),

  features: [
    '14 dias de uso gratuito',
    'Não é necessário dados bancários',
    'Todas as funcionalidades'
  ],

  mixins: [ MediaQuery ],

  components: {
    RegistrationContainer,
  },

  props: {
    appUrl: String
  },

  methods: {
    async redirect () {
      window.open(this.appUrl, '_top')
    }
  },

  computed: {
    noHeading () {
      return !!this.$route.query.noHeading
    }
  },

  created () {
    document.body.classList.add('embed-page');
  },
}
</script>

<style lang="scss">
.embed-page {
  background: transparent;

  > .app > .view-register {
    min-height: 100%;
    position: relative;

    @include responsive (tablet, desktop) {
      grid-template-columns: 1fr;
      height: 100%;
      overflow-x: hidden;
      transform: translateX(0);
      transition: transform .5s, width .5s;
    }

    & > .content {
      background-image: none;
      display: flex;
      flex-direction: column;

      &.submiting {
        overflow: hidden;
      }

      & > .new-register-form {
        margin: 10px;
      }

      & > .new-register-form > .form {
        width: 100%;
      }

      & > .new-register-form > .form > .submit-button {
        max-width: 580px;
        margin-inline: auto;
      }

      @include responsive (xs-mobile, mobile) {
        & > .new-register-form {
          padding: 0;
          margin: 10px;
        }

        & > .new-register-form > .form {
          width: 100%;
          max-width: unset;
        }
      }
    }
  }
}
</style>
